import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SpeechService } from 'src/app/services/speech.service';
declare var MediaRecorder: any;
@Component({
  selector: 'app-user-input',
  templateUrl: './user-input.component.html',
  styleUrls: ['./user-input.component.scss']
})


export class UserInputComponent implements OnInit {

  phoneForm!: FormGroup;
  phoneNumberUtil = PhoneNumberUtil.getInstance();
  @Output() changeScreenValue = new EventEmitter<string>();
  @Output() handleSubmit = new EventEmitter<any>();
  @Output() hadleFileUpload = new EventEmitter<any>();
  @Input() messages: any[] = [];
  @Input() canChangeStyle: any;
  @Output() generatePdf = new EventEmitter<any>();
  @Output() closeLiveChatAgent = new EventEmitter<any>();
  @Input() clientConfigurationData: any;
  @Input() isTyping: any;
  @Input() isAskingPhoneToEnter: any;
  @Input() isAskingEmailToEnter: any;
  @Input() isAskingForAppRating: any;
  @Input() isLiveChat: any;
  styleSheet: CSSStyleSheet | undefined;
  DATA: any;
  audioFlag:boolean = false
  isVoice:boolean = false;
  isFileUpload:boolean = true
  isDownloadTranscript:boolean = false
  isShowPayment:boolean = false
  isShowHelp:boolean = true
  isListening:boolean = false
  IsEmoji:boolean = false
  mediaRecorder:any;
  audioChunks:any = [];
  stream:any;
  isClicked:boolean = false;
  client_logo:any = null;
  phone_number:any;
  currentPopover: any;

  @Input() makeInputDisabled: any = false;
  @Output() fnListening = new EventEmitter<any>();

  
  clientRedirectUrl: any;
  clientMenu: any[] = [];


  @ViewChild('messageInput') messageInput!: ElementRef;

  constructor(private fb: FormBuilder,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private speechService: SpeechService,
  ) {}

  ngOnInit() {
    

    this.phoneForm = this.fb.group({
      phone: ['', [Validators.required]]
    });

    if(this.clientConfigurationData){

      this.client_logo = this.clientConfigurationData.client_logo
      this.clientRedirectUrl = this.clientConfigurationData.client_url
      this.clientMenu = this.clientConfigurationData.client_menu      
      this.isFileUpload  = this.fnCheckFeature('IsAttachment')
      this.isVoice  = this.fnCheckFeature('IsVoice')
      //this.isVoice  = true
      this.isDownloadTranscript  = this.fnCheckFeature('IsChatTranscript')
      this.IsEmoji  = this.fnCheckFeature('IsEmoji')
     // console.log('checkFeature',this.fnCheckFeature('IsWelcomeScreenDisabled'))
      // if(this.clientConfigurationData.IsAttachment && this.clientConfigurationData.IsAttachment){
      //   this.isFileUpload = true;
      // }
      // if(this.clientConfigurationData.IsAttachment && this.clientConfigurationData.IsAttachment){
      //   this.isFileUpload = true;
      // }
    }
    if(this.canChangeStyle){
      this.DATA = this.clientConfigurationData;
      this.fnSetStyles();
    }else{
      this.fnSetDefaultStyles();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.focusInput(); // Focus input after view initialization
    }, 1000);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['messages'] || changes['isTyping']) {
      // alert("changes")
      this.handleTypingOrMessageUpdate();
      this.cdr.detectChanges();

      setTimeout(() => {
        this.focusInput(); // Focus input after view initialization
        setTimeout(() => {
          this.cdr.detectChanges();
        }, 200);
      }, 500);
    }
  }

  handleTypingOrMessageUpdate() {
    if (!this.isTyping) {
      this.focusInput();  // Focus when typing is false
      this.cdr.detectChanges();

    }
  }

  // Method to check and set focus dynamically
  
  focusInput() {
    // Check if the input exists and isn't disabled
    if (this.messageInput && !this.messageInput.nativeElement.disabled) {
      setTimeout(() => {
        this.messageInput.nativeElement.focus();
      this.cdr.detectChanges();

      }, 100); // Use timeout to avoid timing issues
    }
  }


  fnCheckFeature(feature:any){
    let flag = false;
    for (const key in this.clientConfigurationData) {
      if (Object.prototype.hasOwnProperty.call(this.clientConfigurationData, feature)) {
        if(this.clientConfigurationData[feature] !=undefined && this.clientConfigurationData[feature] == true || this.clientConfigurationData[feature] == 'true')
        flag = true; 

      }
    }
    return flag
  }

  isValidEmail(email: string): boolean {
    const emailPattern = /^[a-zA-Z0-9]+([._][a-zA-Z0-9]+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }

  isMenuVisible:boolean = false;
  isEmojiPickerVisible: boolean= false;
  message:string = '';
  toggleMenuButton() {

    if(this.isMenuVisible){
      this.isMenuVisible = false;
      return;
    }
    
    setTimeout(() => {
      this.isMenuVisible = !this.isMenuVisible;
    }, 100);
    
  }

  handleClick(value:string){
    if(value === "menu"){
      const data = {
        value:"go back to main menu",
        text:"main menu"
      }
      this.isMenuVisible = !this.isMenuVisible;
      this.handleSubmit.emit(data);
    }else{
      this.isMenuVisible = !this.isMenuVisible;
      this.handleSubmit.emit(value);
    }
  }

  handleEventEnter(){

    if(this.isAskingEmailToEnter){
      if(!this.isValidEmail(this.message)){
        return;
      }
    }

    if (this.phoneForm.valid && this.isAskingPhoneToEnter) {
      const phoneNumber = this.phoneForm.get('phone')?.value;

      if (!this.isPhoneNumberValid(phoneNumber)) {
        return
      }
      else {
         console.log('Phone number is valid:', phoneNumber);
        this.isAskingPhoneToEnter = false;
        this.message = phoneNumber.internationalNumber;
    
      }
    }

    if(this.isTyping){
      return;
    }

    if(this.message.trim() === "") return;

    this.handleSubmit.emit(this.message);
    this.message = ""
    setTimeout(() => {
      this.isTyping = false;  // Reset typing state
      this.focusInput();  // Re-focus input when typing is done
      this.cdr.detectChanges();  // Ensure UI updates correctly
    }, 1000);  // Simulate message response delay

  }

  handleOpenFileUplaodModel(){
    this.isMenuVisible = !this.isMenuVisible;
    this.hadleFileUpload.emit();
  }


  public addEmoji(event:any) {
    this.message = `${this.message}${event.emoji.native}`;
  }


  handleAddPayment(){
    this.isMenuVisible = !this.isMenuVisible;
    this.changeScreenValue.emit("payment");
  }

  fnSetStyles() {
    let style = document.createElement("style");
    style.appendChild(document.createTextNode(""));
    document.head.appendChild(style);
    this.styleSheet = style.sheet as CSSStyleSheet;

    this.styleSheet.insertRule(`
    .bottom-bot-div {
      border-top: 1px solid ${this.DATA.PrimaryColor} !important;
    }
  `);
  
  this.styleSheet.insertRule(`
    .custom-icon-color {
      color: ${this.DATA.PrimaryColor} !important;
    }
  `);
  
  this.styleSheet.insertRule(`
    .send-btn {
      color: ${this.DATA.PrimaryColor} !important;
    }
  `);

  }

  
  fnSetDefaultStyles() {
    let style = document.createElement("style");
    style.appendChild(document.createTextNode(""));
    document.head.appendChild(style);
    this.styleSheet = style.sheet as CSSStyleSheet;
   

    this.styleSheet.insertRule(`
    .bottom-bot-div {
      border-top: 1px solid #44444462; !important;
    }
  `);

  this.styleSheet.insertRule(`
    .custom-icon-color {
      color: #386278; !important;
    }
  `);

  this.styleSheet.insertRule(`
    .send-btn {
      color: #386278; !important;
    }
  `);

  }


  handleClickOnHelp(){

    this.isMenuVisible = !this.isMenuVisible;

    // redirec to gravitas.ai
    window.open('https://gravitas.ai', '_blank');
  }



  generatePDF() {
    this.generatePdf.emit();
  }

  async fnRecordVoice() {
   let context = this;
    this.audioFlag = true;
    this.isListening = true;

    try{
     
        this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      
    }catch(e){
      this.isListening = false;
      this.audioFlag = false;
      console.error('Could not get audio stream');
      console.error(e)
      return;
    }

    // if use denied
    if (!this.stream) {
      this.isListening = false;
      this.audioFlag = false;
      console.error('Could not get audio stream');
      return;
    }

    this.mediaRecorder = new MediaRecorder(this.stream);
    this.mediaRecorder.ondataavailable = (event: { data: { size: number; } | null; }) => {
      if (event.data && event.data.size > 0) {
        this.audioChunks.push(event.data);
      }
    };
  this.mediaRecorder.onstop = () => {
    const audioBlob = new Blob( this.audioChunks, { type: 'audio/wav' });
    const reader:any = new FileReader();

    reader.readAsDataURL(audioBlob);
    reader.onloadend = function() {
      let audioBase64 = reader.result.split(',')[1];
      //console.log(audioBase64)
      const data = {
        audio:audioBase64,

      }
     
      context.handleSubmit.emit(data);

    };
  };

  this.mediaRecorder.start();
  setTimeout(() => {
    if (this.audioFlag) {
      this.audioFlag = false;
      this.audioChunks = [];
      this.isListening = false;
      this.stopRecording();
    }
  }, 3 * 1000);
  }

   stopRecording() {
    if (this.mediaRecorder.state !== 'inactive') {
      this.mediaRecorder.stop();
      this.stream.getTracks().forEach((track: { stop: () => any; }) => track.stop());
    }
  }

  handleClickOutside() {
   
    if(this.isMenuVisible){
      this.isMenuVisible = false;
    }

  }


  onSubmit() {
    if (this.phoneForm.valid) {
      const phoneNumber = this.phoneForm.get('phone')?.value;

      if (this.isPhoneNumberValid(phoneNumber)) {
        console.log('Phone number is valid:', phoneNumber);
        this.message = phoneNumber.dialCode+"-"+phoneNumber.dialCode;
        this.handleEventEnter();
      } else {
        console.error('Invalid phone number');
      }
    }
  }

  // Custom validation using google-libphonenumber
  isPhoneNumberValid(phoneNumber: any): boolean {

    this.phone_number = phoneNumber.internationalNumber;
    console.log("phone_number",this.phone_number)
    try {
      const parsedNumber = this.phoneNumberUtil.parseAndKeepRawInput(
        phoneNumber.number,
        phoneNumber.countryCode
      );
      return this.phoneNumberUtil.isValidNumber(parsedNumber);
    } catch (error) {
      console.error('Error validating phone number:', error);
      return false;
    }
  }

  
  fnOpenSmallModal(content: any) {

    // close the uploadFileModel model
    if(this.currentPopover){
      this.currentPopover.close();
    }

    let options: any = {
      centered: true,
      size: 'sm',
      backdrop: false,
      keyboard: true,
      scrollable: false
    }
    this.currentPopover = this.modalService.open(content, options);
  }

  closeLiveChat(){
    this.closeLiveChatAgent.emit();
    this.fnCloseModal();
  }

  fnCloseModal(){
    if(this.currentPopover){
      this.currentPopover.close();
    }
  }

  startListening() {
    this.audioFlag = true;
    this.fnListening.emit(true)
    this.isListening = true;
    this.speechService.startListening((text) => {
      this.audioFlag = false;
      this.isListening = false;
     // this.textOutput = text;
      this.fnListening.emit(false)
      this.handleSubmit.emit(text);
      console.log('Recognized text:', text);
    });
  }
}
